
import { useEffect, useRef } from "react";


export default function ourFuture() {


    return (
            <section className="min-h-screen bg-[#0e0e0e] text-white py-20 text-[30rem] leading-tight">
                <div className="container mx-auto px-4 py-20">
                    <h3 className="text-lg font-medium leading-normal tracking-tight">Hopes for 2026</h3>
                    <p className="mt-6 max-w-4xl text-4xl font-light leading-relaxed">
                        <p>
                            As we look toward the 2026 season, RGU Motorsport is focused on pushing
                            the team further than ever before. With new members joining across
                            engineering and business roles, we aim to build on the knowledge and
                            experience gained in previous years.
                        </p>
                        <br/>
                        <p>
                            Our goal is to continue refining our design process, improving the
                            performance and reliability of our car, and strengthening the teamwork
                            that drives the project forward. Every season presents new challenges,
                            but it also provides an opportunity for innovation and growth.
                        </p>
                        <br/>
                        <p>
                            With the support of our partners and the dedication of our student team,
                            we are excited to see what we can achieve in 2026 as we continue our
                            journey in motorsport engineering.
                        </p>
                    </p>
                </div>
            </section>
    );
}
